import ScrollReveal from "./ScrollReveal";
import { AlertTriangle, Clock, Hammer, BadgeEuro } from "lucide-react";

export default function ProblemSection() {
  return (
    <section data-testid="problem-section" className="py-24 lg:py-36 bg-[#0284FC]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <ScrollReveal>
            <div className="space-y-6">
              <h2 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight text-white">
                Pourquoi changer toute une cuisine ?
              </h2>
              <p className="text-base sm:text-lg text-white/70 leading-relaxed">
                Votre cuisine est encore fonctionnelle mais visuellement dépassée ?
              </p>
              <p className="text-base sm:text-lg text-white/70 leading-relaxed">
                Remplacer une cuisine complète peut coûter{" "}
                <span className="font-bold text-white">plus de 10 000 &euro;</span>{" "}
                et implique souvent plusieurs semaines de travaux, de bruit et de contraintes.
              </p>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={0.15}>
            <div className="grid grid-cols-2 gap-4">
              {[
                { icon: BadgeEuro, label: "+10 000 \u20AC", desc: "Budget moyen remplacement" },
                { icon: Clock, label: "3 à 6 semaines", desc: "Durée des travaux" },
                { icon: Hammer, label: "Démolition", desc: "Bruit et poussière" },
                { icon: AlertTriangle, label: "Contraintes", desc: "Cuisine inutilisable" },
              ].map((item) => (
                <div
                  key={item.label}
                  className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/15 hover:-translate-y-1 hover:bg-white/15 transition-all duration-300"
                >
                  <div className="w-10 h-10 rounded-xl bg-white/15 flex items-center justify-center mb-3">
                    <item.icon className="w-5 h-5 text-white" />
                  </div>
                  <div className="font-heading font-bold text-white text-lg">{item.label}</div>
                  <div className="text-sm text-white/60 mt-1">{item.desc}</div>
                </div>
              ))}
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}
